import { Flex } from 'reflexbox';

import { Checkbox, Paragraph } from '@treams/treams-ui';

const ListFilterCheckbox = ({
	options,
}: {
	options: { label: string; name: string; value: string; tintColor?: string }[];
}) => {
	const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));
	return (
		<>
			{sortedOptions.map((option, index) => (
				<Flex mb={index < options.length - 1 ? 2 : 0} key={index}>
					<Checkbox.Formik name={option.name} value={option.value} />

					<Paragraph ml={2}>{option.label}</Paragraph>
				</Flex>
			))}
		</>
	);
};

export default ListFilterCheckbox;
